import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { Nav } from "@/components/Nav";
import { Hero, Ticker } from "@/components/Hero";
import { Services } from "@/components/Services";
import { Signature } from "@/components/Signature";
import { InstagramSection } from "@/components/InstagramSection";
import { EnquiryForm } from "@/components/EnquiryForm";
import { Footer } from "@/components/Footer";

const LandingPage = () => {
  return (
    <div data-testid="landing-page" className="min-h-screen bg-[#130F0D] text-[#E6D5C3]">
      <Nav />
      <main>
        <Hero />
        <Ticker />
        <Services />
        <Signature />
        <InstagramSection />
        <EnquiryForm />
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        theme="dark"
        toastOptions={{
          style: {
            background: "#241D1A",
            border: "1px solid #332A24",
            color: "#E6D5C3",
            borderRadius: 0,
          },
        }}
      />
    </div>
  );
}

export default App;
